import { BMCS_COOKIE_CONSENT_KEY } from '../../components/CookieConsentBanner';

export const BMCS_TELEMETRY_VISITOR_KEY = 'bmcs_telemetry_vid';

export function hasCookieConsentForTelemetry(): boolean {
  try {
    return localStorage.getItem(BMCS_COOKIE_CONSENT_KEY) === 'accepted';
  } catch {
    return false;
  }
}

/** Returns a stable UUID once consent is granted; otherwise null. */
export function getOrCreateTelemetryVisitorId(): string | null {
  if (!hasCookieConsentForTelemetry()) return null;
  try {
    let id = localStorage.getItem(BMCS_TELEMETRY_VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(BMCS_TELEMETRY_VISITOR_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function getStoredTelemetryVisitorId(): string | null {
  try {
    return localStorage.getItem(BMCS_TELEMETRY_VISITOR_KEY);
  } catch {
    return null;
  }
}

export function clearTelemetryVisitorId(): void {
  try {
    localStorage.removeItem(BMCS_TELEMETRY_VISITOR_KEY);
  } catch {
    // ignore
  }
}
